export const clientsInfo = {
  client1: {
    name: "client1",
    country: "Estados Unidos",
    city: "California",
    zip: 94203,

    projectName: "Portfolio Webpage",
    projectDescription: "Valentin Galfre's Portfolio"
  },
  client2: {
    name: "client2",
    country: "Estados Unidos",
    city: "California",
    zip: 94203,

    projectName: "Crombie Docs",
    projectDescription: "A webpage for making presentations"
  }
};
